import { ColorPicker } from 'modules/Editor/components/ColorPicker';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { isTransparent } from 'utils/color';

import { onColorPickerContainerBlur } from '../../common/TextBasedWidgets.helpers';
import { MenuProps } from '../../common/toolbar/TextToolbar.types';

export const CellColor = memo(({ value, onChange, onClose }: MenuProps) => {
  // Old tables have been added with rgba(0, 0, 0, 0) as the default cell color -> but we want to display transparent
  const formattedValue = isTransparent(value) ? 'transparent' : value;
  const { t } = useTranslation('editor_widget_toolbar', { keyPrefix: 'tableToolbar', useSuspense: false });
  const label = t('cell.label');

  return (
    <ColorPicker
      iconStyle='fill'
      label={label}
      color={formattedValue}
      onChange={onChange}
      onClose={onClose}
      onContainerBlur={onColorPickerContainerBlur}
      showNoColorOption
      showNoColorChecker
    />
  );
});
CellColor.displayName = 'CellColor';
